import { call, put, select } from 'redux-saga/effects';

import { setOrganizationDetails } from '../../effects/organization';
import { callAPI, METHODS } from '../api';
import { RESOURCES } from '../../../helpers/constants';
import { setBannerAPIRequestState } from '../../effects/message';

export default function* updateOrganizationName(action) {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);

  const url = `${dpaApiBaseUrl + RESOURCES.ORGA}/${organizationId}`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.PUT,
      body: { name: action.payload.name },
    });

    if (success && !error) {
      yield put(setOrganizationDetails({ ...result }));
    } else if (action.payload.showBannerFeedback) {
      yield put(setOrganizationDetails());
      yield put(
        setBannerAPIRequestState({
          bannerState: 'error',
          bannerMessage: 'Something went wrong while updating your profile...',
        }),
      );
    }
  } catch (e) {
    console.error(e);
    if (action.payload.showBannerFeedback) {
      yield put(setOrganizationDetails());
      yield put(
        setBannerAPIRequestState({
          bannerState: 'error',
          bannerMessage: 'Something went wrong while updating your profile...',
        }),
      );
    }
  }
}
